// src/pages/MainLayout.js
import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const MainLayout = ({ children }) => {
  // Add state for modals
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFrameModalOpen, setIsFrameModalOpen] = useState(false);

  // Clone children with props if needed
  const childrenWithProps = React.Children.map(children, child => {
    // Check if it's a valid React element before cloning
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { 
        isModalOpen, 
        setIsModalOpen, 
        isFrameModalOpen, 
        setIsFrameModalOpen 
      });
    }
    return child;
  });

  return (
    <div>
      <Navbar 
        setIsModalOpen={setIsModalOpen} 
        setIsFrameModalOpen={setIsFrameModalOpen} 
      />
      <div className="scroll-container">{childrenWithProps}</div>
      <Footer />
    </div>
  );
};

export default MainLayout;